<template>
	<div class="ui--zoom" role="text" tabindex="0" ref="ref">
		<div class="button--close" role="button" @click="close" />
		<Spinner stroke="#fff" v-if="!loaded" />
		<PinchZoom ref="myPinch" :limitZoom="32">
			<img
				:src="`${source}/2048`"
				:alt="alt"
				:class="{
					loaded: loaded,
				}"
				@load="load"
			/>
		</PinchZoom>
	</div>
</template>
<script>
import PinchZoom from 'vue-pinch-zoom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Spinner from '@/components/elementSub/spinner.vue';

export default {
	name: 'Zoom',
	props: {},
	components: {
		PinchZoom,
		Spinner,
	},
	data() {
		return {
			loaded: false,
		};
	},
	computed: {
		mediaId() {
			return this.$store.getters.getZoomMediaId;
		},
		mediaObject() {
			return this.$store.state.currentMediaObjectMap.get(this.mediaId);
		},
		source() {
			if (!this.mediaObject) return;
			const source = this.mediaObject.Sources[this.$store.state.persistent.language];
			if (!source) return null;
			return source.endsWith('/1024') ? source.replace('/1024', '') : source;
		},
		alt() {
			return this.mediaObject.Alt[this.$store.state.persistent.language];
		},
	},
	methods: {
		close() {
			this.$store.dispatch('closeZoom');
		},
		load() {
			this.loaded = true;
		},
	},
	mounted() {
		this.$nextTick(() => {
			disableBodyScroll(this.$refs.ref);
			// this.$refs['myPinch'].toggleZoom();
		});
	},
	beforeDestroy() {
		enableBodyScroll(this.$refs.ref);
	},
};
</script>
<style scoped>
img {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100vw;
	height: 100vh;
	display: block;
	object-fit: contain;
	object-position: center;
	opacity: 0;
	transition: 0.5s opacity;
}
img.loaded {
	opacity: 1;
}
</style>
